import Mutations from '../../odata/mutations';

export default { ...new Mutations('extensionFeedback'), ...new Mutations('extensionFeedbacks') };
